import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'sanitize.css/sanitize.css';
import './index.css';
import './locales/i18n';

import { remoteConfigReady } from '@service/firebase';
import UserManagerClient from '@service/UserManagerClient';
import App from 'app';
import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';

import log from './datadog';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

const renderApp = async () => {
  log.initialize();

  await remoteConfigReady;

  const oidcConfig = {
    userManager: UserManagerClient,
    onSigninCallback: () => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  };

  return ReactDOMClient.createRoot(MOUNT_NODE).render(
    <HelmetProvider>
      <AuthProvider {...oidcConfig}>
        <BrowserRouter>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>,
  );
};

renderApp();
